import { Col, Flex, Row } from 'antd';
import { Text } from 'components/mvp-typography';
import React, { useMemo } from 'react';
import { CheckoutSessionCard } from './checkout-session-button';

export interface SubscriptionPackagesProps {
  productsData?: {
    prices: {
      id: string;
      unit_amount: number | null;
      lookup_key: string | null;
      type: 'one_time' | 'recurring';
      product: {
        id: string;
        name: string;
        marketing_features: {
          name: string;
        }[];
      };
    }[];
    currency: string;
  };
}

export function SubscriptionPackages({
  productsData
}: SubscriptionPackagesProps) {
  const sortedPrices = useMemo(
    () =>
      [...(productsData?.prices || [])]
        .filter(_ => _.type === 'recurring')
        .sort((a, b) => (a.unit_amount ?? 0) - (b.unit_amount ?? 0)),
    [productsData?.prices]
  );

  if (sortedPrices.length === 0) {
    return (
      <Flex
        align="center"
        justify="center"
        style={{ width: '100%', minHeight: '100px' }}
      >
        <Text>
          No packages are available for your organisation at this time. Please
          contact sales@concussionrx.com to find a product that works for you.
        </Text>
      </Flex>
    );
  }

  return (
    <Row gutter={[16, 16]}>
      {sortedPrices.map(price => {
        const formattedPrice = Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: productsData?.currency || 'cad'
        }).format((price.unit_amount ?? 0) / 100);

        const productId = (price as any).product?.id || price.id;
        return (
          <Col key={price.id}>
            <CheckoutSessionCard
              price={formattedPrice}
              productId={productId}
              title={price.product.name}
              priceFrequency={'per year'}
              features={price.product.marketing_features.map(_ => _.name)}
              buttonText="Start Now"
              priceSubtext={'Billed annualy.'}
            />
          </Col>
        );
      })}
    </Row>
  );
}
